import { useState } from "react";
import { Download, X } from "lucide-react";
import api from "@/lib/api";

/**
 * Soft-gate download modal. Default checkbox CHECKED.
 * onConfirm receives ({email, subscribe}) and is responsible for triggering the download.
 */
export default function DownloadGateModal({ open, onClose, downloadUrl, title = "Tu descarga está lista", subtitle = "Guarda el PDF en tu equipo. Si quieres, déjanos tu email para recibir nuevas historias." }) {
  const [email, setEmail] = useState("");
  const [subscribe, setSubscribe] = useState(true);
  const [busy, setBusy] = useState(false);

  if (!open) return null;

  const trigger = async (withEmail) => {
    setBusy(true);
    try {
      let url = downloadUrl;
      if (withEmail && email.trim() && subscribe) {
        const sep = url.includes("?") ? "&" : "?";
        url = `${url}${sep}email=${encodeURIComponent(email.trim())}&subscribe=1`;
      }
      window.open(url, "_blank", "noopener");
      setTimeout(onClose, 600);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="download-gate-modal" className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-charcoal/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-cream max-w-lg w-full p-8 md:p-10 rounded-sm border border-gold/30 shadow-2xl">
        <button onClick={onClose} className="absolute top-4 right-4 h-9 w-9 inline-flex items-center justify-center text-charcoal/50 hover:text-charcoal" aria-label="Cerrar"><X className="h-4 w-4" /></button>
        <p className="text-[10px] uppercase tracking-[0.28em] text-terracotta mb-3">Descarga</p>
        <h3 className="font-serif text-2xl md:text-3xl font-light text-charcoal leading-tight mb-3">{title}</h3>
        <p className="text-charcoal/70 text-sm mb-7">{subtitle}</p>

        <div className="space-y-4">
          <label className="flex items-start gap-3 text-sm text-charcoal cursor-pointer select-none">
            <input data-testid="gate-subscribe" type="checkbox" checked={subscribe} onChange={(e) => setSubscribe(e.target.checked)} className="accent-terracotta mt-0.5" />
            <span>Quiero recibir las nuevas historias por email.</span>
          </label>
          <input
            data-testid="gate-email"
            type="email"
            placeholder="Email opcional"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={!subscribe}
            className="w-full bg-white border border-charcoal/20 rounded-sm px-4 py-3 text-sm text-charcoal placeholder:text-charcoal/40 focus:border-terracotta focus:outline-none disabled:opacity-50"
          />

          <div className="flex flex-col sm:flex-row gap-3 pt-3">
            <button
              data-testid="gate-download"
              onClick={() => trigger(true)}
              disabled={busy}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-terracotta text-cream px-6 py-3 text-sm font-medium hover:bg-[#A64826] transition-all flex-1 disabled:opacity-60"
            >
              <Download className="h-4 w-4" /> Descargar ahora
            </button>
            <button
              data-testid="gate-skip"
              onClick={() => trigger(false)}
              disabled={busy}
              className="text-xs uppercase tracking-[0.2em] text-charcoal/60 hover:text-charcoal py-2 px-4"
            >
              Descargar sin email
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
